/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card, Alert } from 'react-bootstrap';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import differenceInYears from 'date-fns/differenceInYears';
import addDays from 'date-fns/addDays';
import add from 'date-fns/add';
import { CiBank, CiWallet } from 'react-icons/ci';
import { MdOutlineCreditCard } from 'react-icons/md';
import {
  getInsuarnceIds,
  getInsuranceInfo,
  getUserDetails,
} from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import './VisaPage.scss';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  emailFlightOptions,
  getFlightTicketApi,
  getPaymentGateway,
} from '../../api/flightApi';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  formatCurrency,
  formatCurrencyWithoutSymbol,
  formatDate,
  getEligibilityForPaymentMode,
  getEligibilityForPgOptions,
  getNewDate,
  isEmpty,
  isValidMobileNumber,
  scrollToTop,
} from '../../shared/helper-utils/appUtils';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  API_DATE_FORMAT,
  DATE_MONTH_YEAR_WITH_HYPHEN,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { mobileCodesForVerification } from '../profile/AgentRegistration';

function InsurancePageNewV3() {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [singleTripCategoryOptions, setSingleTripCategoryOptions] = useState(
    [],
  );
  const [annualTripCategoryOptions, setAnnualTripCategoryOptions] = useState(
    [],
  );
  const [alert, setAlert] = useState(undefined);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCategoryCode, setSelectedCategoryCode] = useState('');
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanId, setSlectedPlanId] = useState('');
  const [choosenPlan, setChoosenPlan] = useState({});
  const [depDate, setDepDate] = useState('');
  const [arrDate, setArrDate] = useState('');
  const [numDays, setNumDays] = useState('');
  const [numPax, setNumPax] = useState(1);
  const [txId, setTxId] = useState('');
  const [leadPaxDob, setLeadPaxDob] = useState('');
  const [leadpaxAge, setLeadPaxAge] = useState('');
  const [documentsRequired, setDocumentsRequired] = useState([]);
  const [ridesAvailable, setRidesAvailable] = useState([]);
  const [validationError, setValidationError] = useState(false);
  const [paxDetails, setPaxDetails] = useState([
    {
      paxname: '',
      address1: '',
      address2: '',
      district: '',
      stateName: '',
      zipCode: '',
      country: '',
      phoneNum: '',
      mobile: '',
      email: '',
      nominee: '',
      relation: '',
      passportnumber: '',
      age: '',
      dob: '',
    },
  ]);
  const [paymentmode, setPaymentMode] = useState('');
  const selectedPaymentGatewayRef = useRef([]);
  const [selectedPg, setSelectedPg] = useState('');
  const [tempPgList, setTempPgList] = useState([]);
  // const [paxDatesObj, setPaxDatesObj] = useState([]);
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [showFooter, setShowFooter] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [costDetails, setCostDetails] = useState({
    basecharges: 0,
    handlingcharges: 0,
    servicetax: 0,
    educess: 0,
    higheducess: 0,
    commission: 0,
    tds: 0,
    othertaxes: 0,
  });
  const [selectedRiderCodes, setSelectedRidersCode] = useState([]);
  const [riderAmount, setRiderAmount] = useState(0);
  const [isContinue, setIsContinue] = useState(false);
  const [domInt, setDomint] = useState('');
  const [planBenifits, setPlanBenifits] = useState([]);
  const [showBenifitsPopup, setShowBenifitsPopup] = useState(false);
  const [hasDetails, setHasDetails] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailToSent, setEmailToSent] = useState('');
  const [emailPlans, setEmailPlans] = useState([]);
  const [searchTab, setSearchTab] = useState(true);
  const [resultsTab, setResultsTab] = useState(false);
  const [detailsTab, setDetailsTab] = useState(false);
  const [reviewTab, setReviewTab] = useState(false);
  const [confTab, setConfTab] = useState(false);
  const [successTxId, setSuccessTxId] = useState('');
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [PaymentGateway, setPaymentGateway] = useState(false);
  const [showFareModal, setShowFareModal] = useState(false);
  const [fareDetails, setFareDetails] = useState(null);
  const [passportValidationError, setPassportValidationError] = useState({});
  const paxDropDown = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
  ];
  const relationDropDown = [
    { label: 'Brother', value: 'Brother' },
    { label: 'Child', value: 'Child' },
    { label: 'Employer', value: 'Employer' },
    { label: 'Father', value: 'Father' },
    { label: 'Legal Guardian', value: 'Legal Guardian' },
    { label: 'Mother', value: 'Mother' },
    { label: 'Sister', value: 'Sister' },
    { label: 'Spouse', value: 'Spouse' },
  ];
  const [tripType, setTripType] = useState('single');
  const [selectedTab, setSelectedTab] = useState('search');
  const [countryCode, setCountryCode] = useState(appConfig.appCountryCode);

  const handleCheckboxChange = (item) => {
    setEmailPlans((prevSelected) => {
      if (
        prevSelected.some((selected) => selected.recordid === item.recordid)
      ) {
        // Remove item if already selected
        return prevSelected.filter(
          (selected) => selected.recordid !== item.recordid,
        );
      } else {
        // Add item if not selected
        return [...prevSelected, item];
      }
    });
  };

  const handleGetPlanBenifits = async (list) => {
    setPlanBenifits(list);
    setShowBenifitsPopup(true);
  };

  const handleSubmit = () => {
    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(selectedCategory) ||
        isEmpty(selectedPlan) ||
        isEmpty(depDate) ||
        isEmpty(arrDate) ||
        isEmpty(numDays) ||
        isEmpty(paxDetail.paxname) ||
        isEmpty(paxDetail.address1) ||
        isEmpty(paxDetail.district) ||
        isEmpty(paxDetail.city) ||
        isEmpty(paxDetail.state) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.country) ||
        isEmpty(paxDetail.phoneno) ||
        isEmpty(paxDetail.mobile) ||
        isEmpty(paxDetail.emailaddress) ||
        isEmpty(paxDetail.nominee) ||
        isEmpty(paxDetail.relation) ||
        isEmpty(paxDetail.dob)
      ) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
      if (isEmpty(paxDetail.passportnumber)) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });
    setShowFooter(true);
  };

  const checkDuplicatePassports = () => {
    const passportNumbers = paxDetails
      .map((pax) => pax.passportnumber?.trim().toLowerCase())
      .filter((passport) => passport !== '');

    const duplicates = passportNumbers.filter(
      (passport, index) => passportNumbers.indexOf(passport) !== index,
    );

    return duplicates.length > 0;
  };
  const getAgeForPax = (dob) => {
    try {
      if (!isEmpty(dob)) {
        const numYears = differenceInYears(
          getNewDate(TODAY_DATE),
          getNewDate(dob),
        );
        return numYears;
      }
      return '';
    } catch (error) {
      return '';
    }
  };

  const handleUpdatePaxDetails = (name, value, index) => {
    const list = [...paxDetails];
    list[index][name] = value;
    // if (name === 'dob') {
    //   const paxAge = getAgeForPax(value);
    //   list[index].age = paxAge;
    // }
    // const paxAge = getAgeForPax(leadPaxDob);
    // list[index].dob = formatDate(leadPaxDob, API_DATE_FORMAT);
    // list[index].age = paxAge;
    setPaxDetails(list);
  };

  const handleUpdateState = (name, value, index = 0) => {
    if (name === 'relation') {
      setPaxDetails((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [name]: value.value,
          passportnumber: prev[index]?.passportnumber || '',
        },
      }));
    } else {
      setPaxDetails((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [name]: value,
        },
      }));
    }
  };

  const getData = async () => {
    setIsLoading(true);
    const request = {
      actioncode: 'GETALLCATEGORIESV2',
    };
    const res = await getInsuarnceIds(request);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      let { categories } = res.ApiStatus.Result;
      categories = Array.isArray(categories) ? categories : [categories];
      const UpdatedList = categories.map((x) => ({
        ...x,
        label: x.categorydescription,
        value: x.categoryid,
      }));
      setCategoryOptions(UpdatedList);
    } else {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.ApiStatus?.Status || 'Failed to fetch details',
      });
    }
    const response = await getPaymentGateway(getUserAgentId());
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const availPgs = response?.Root?.Result?.AvailablePaymentGateways;
      if (availPgs !== '' && availPgs !== undefined && availPgs !== null) {
        let pglist = availPgs.AvailablePaymentGateway;
        pglist = Array.isArray(pglist) ? pglist : [pglist];
        selectedPaymentGatewayRef.current = pglist;
        const pgForCreditCard = pglist.filter(
          (x) => x.PaymentMode.toLowerCase() === 'creditcard',
        );
        setTempPgList(pgForCreditCard);
        if (pgForCreditCard.length > 0) {
          setSelectedPg(pgForCreditCard[0].GatewayName);
        }
        setPaymentGateway(true);
      }
    }

    setIsLoading(false);
  };

  const getPlanRelatedDetails = async (value) => {
    setRidesAvailable(value);
  };

  const handleGetTxDetails = async () => {
    if (txId !== '') {
      setIsLoading(true);
      const res = await getFlightTicketApi(txId, getUserAgentId());
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        const { FlightInvoice } = res.ApiStatus.Result.FullFlightDetails;
        const { FlightRecord } = FlightInvoice;
        const fullName = `${FlightRecord.PassengerFirstName} ${FlightRecord.PassengerLastName}`;
        handleUpdateState('paxname', fullName);
      } else {
        setAlert({
          variant: 'error',
          title: 'Pax Details',
          description: 'Failed to fetch details',
        });
      }
      setIsLoading(false);
    }
  };
  const resetResults = () => {
    setTxId('');
    setLeadPaxDob('');
    setDocumentsRequired([]);
    setRidesAvailable([]);
    setSelectedRidersCode([]);
    setValidationError(false);
    setDepDate('');
    setArrDate('');
    setNumDays('');
    setNumPax(1);
    setPaxDetails([
      {
        paxname: '',
        address1: '',
        address2: '',
        district: '',
        stateName: '',
        zipCode: '',
        country: '',
        phoneNum: '',
        mobile: '',
        email: '',
        nominee: '',
        relation: '',
        passportnumber: '',
        age: '',
        dob: '',
      },
    ]);
    setTotalInvoice(0);
    setShowFooter(false);
    setAcceptTerms(false);
    setCostDetails({
      basecharges: 0,
      handlingcharges: 0,
      servicetax: 0,
      educess: 0,
      higheducess: 0,
      commission: 0,
      tds: 0,
      othetaxes: 0,
    });
    setSelectedRidersCode([]);
    setRiderAmount(0);
  };
  const handleCategorySelect = (e) => {
    try {
      const { value, domint, categorycode } = e;
      setSelectedCategory(value);
      setSelectedCategoryCode(categorycode);
      setDomint(domint);

      resetResults();
      if (value !== '') {
        setSelectedPlan('');
        setSlectedPlanId('');
      }
    } catch (error) {
      //
    }
  };

  const getFareManageMentForPlan = async (plan) => {
    const ages = paxDetails.map((obj) => obj.age).join('#');
    setIsLoading(true);

    const req = {
      actioncode: 'GETTIFAREV2',
      agentid: getUserAgentId(),
      premiumamount: plan?.totalpremium,
      plancode: plan.planid,
      premiumid: plan.planid,
      noofpax: numPax,
      agelimit: ages,
      apiname: 'dolphininsurance',
    };

    const res = await getInsuranceInfo(req);

    if (
      res &&
      res.Root &&
      res.Root.Status === 'OK' &&
      !isEmpty(res.Root.Result) &&
      !isEmpty(res.Root.Result.FlightFare)
    ) {
      const { FlightFare } = res.Root.Result;

      const {
        BaseFare,
        Commission,
        ServiceTax,
        Tds,
        HandlingCharges,
        InvoiceTotal,
      } = FlightFare;

      setCostDetails((prev) => ({
        ...prev,
        basecharges: BaseFare,
        handlingcharges: HandlingCharges,
        servicetax: ServiceTax,
        tds: Tds,
        commission: Commission,
      }));

      setTotalInvoice(InvoiceTotal);

      setIsLoading(false);

      return FlightFare;
    } else {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.Root?.Message || 'Failed to fetch Fare Details',
      });

      setIsLoading(false);
      return null;
    }
  };

  const handleContinue = () => {
    setShowFareModal(false);
    setHasDetails(true);
    setSelectedTab('details');
    setDetailsTab(true);
  };

  const handlePlanSelect = async (plan) => {
    try {
      setChoosenPlan(plan);
      setSelectedPlan(plan.planid);
      setSlectedPlanId(plan.planid);
      setValidationError(false);

      await getPlanRelatedDetails(plan?.riders);

      const fare = await getFareManageMentForPlan(plan);

      if (fare) {
        setFareDetails(fare);
        if (appConfig?.showDiscountedPrice) {
          setShowFareModal(true);
        } else {
          handleContinue();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handelSetDepDate = (date) => {
    setDepDate(date);
    if (!isEmpty(arrDate)) {
      const diffInDays = differenceInCalendarDays(
        getNewDate(arrDate),
        getNewDate(date),
      );
      setNumDays(diffInDays + 1);
    }
  };
  const handelSetArrDate = (date) => {
    setArrDate(date);
    if (!isEmpty(depDate)) {
      const diffInDays = differenceInCalendarDays(
        getNewDate(date),
        getNewDate(depDate),
      );
      setNumDays(diffInDays + 1);
    }
  };

  const setAge = (name, value, index) => {
    // const age = differenceInYears(getNewDate(TODAY_DATE), getNewDate(value));
    const age = differenceInYears(depDate, getNewDate(value));
    setPaxDetails((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [name]: age.toString(),
      },
    }));
  };

  const handleDobSelect = (name, value, index) => {
    const paxdob = formatDate(getNewDate(value), DATE_MONTH_YEAR_WITH_HYPHEN);
    // setDob(date)
    setPaxDetails((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [name]: paxdob,
      },
    }));

    setAge('age', value, index);
  };
  const handleNumDaysChange = (days) => {
    setNumDays(days);
    if (!isEmpty(depDate) && !isEmpty(days)) {
      const numdays = parseInt(days, 10);
      const departureDate = getNewDate(depDate);
      const newDate = addDays(departureDate, numdays);
      setArrDate(newDate);
    }
  };

  const handleContinueBooking = async () => {
    let hasValidationError = false;

    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(selectedCategory) ||
        isEmpty(selectedPlan) ||
        isEmpty(depDate) ||
        isEmpty(arrDate) ||
        isEmpty(numDays) ||
        isEmpty(paxDetail.paxname) ||
        isEmpty(paxDetail.address1) ||
        isEmpty(paxDetail.district) ||
        isEmpty(paxDetail.city) ||
        isEmpty(paxDetail.state) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.country) ||
        isEmpty(paxDetail.phoneno) ||
        isEmpty(paxDetail.mobile) ||
        isEmpty(paxDetail.emailaddress) ||
        isEmpty(paxDetail.nominee) ||
        isEmpty(paxDetail.relation)
      ) {
        hasValidationError = true;
        setValidationError(true);
        scrollToTop();
        return false;
      }
      if (domInt === 'international' && isEmpty(paxDetail.passportnumber)) {
        hasValidationError = true;
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });

    if (hasValidationError) {
      return false;
    }

    if (checkDuplicatePassports()) {
      const newErrors = {};
      const passportNumbers = paxDetails.map((pax) =>
        pax.passportnumber?.trim().toLowerCase(),
      );

      passportNumbers.forEach((passport, index) => {
        if (
          passport &&
          passportNumbers.indexOf(passport) !==
            passportNumbers.lastIndexOf(passport)
        ) {
          newErrors[index] = true;
        }
      });

      setPassportValidationError(newErrors);
      setAlert({
        variant: 'error',
        title: 'Validation Error',
        description: 'Each passenger must have a unique passport number',
      });
      scrollToTop();
      return false;
    }

    setIsLoading(true);

    const priceDetails = {
      ...costDetails,
    };
    Object.values(priceDetails).forEach((value) => {
      if (value === '') {
        value = 0;
      }
    });
    const {
      handlingcharges,
      servicetax,
      educess,
      higheducess,
      commission,
      tds,
      // othertaxes,
    } = priceDetails;

    const { paxname, age, relation, nominee, country, mobile } = paxDetails[0];
    const rideCodes = [];
    selectedRiderCodes.forEach((ride) => {
      rideCodes.push(ride.riderid);
    });
    const ages = paxDetails.map((obj) => obj.age).join('#');
    const list = paxDetails.map((x) => ({
      ...x,
      dob: formatDate(getNewDate(x.dob), API_DATE_FORMAT),
    }));
    const req = {
      apiname: 'dolphininsurance',
      actioncode: 'ISSUEDOLPHINPOLICY',
      opid: 'TRAWELLTAGAPI',
      agentid: getUserAgentId(),
      categorycode: selectedCategory,
      plancode: selectedPlan,
      premiumid: selectedPlanId,
      departuredate: formatDate(getNewDate(depDate), API_DATE_FORMAT),
      arrivaldate: formatDate(getNewDate(arrDate), API_DATE_FORMAT),
      numdays: numDays,
      dob: list[0].dob,
      age,
      domInt: '',
      paxname,
      nominee,
      mobile,
      relation,
      country,
      InsurancePassenger: `{"InsurancePassenger":${JSON.stringify(list)}}`,
      rideramount: riderAmount,
      ridercodes: rideCodes.join(','),
      ...priceDetails,
      basecharges: choosenPlan.totalpremium,
      handlingcharges,
      servicetax,
      educess,
      higheducess,
      commission,
      tds,
      // othertaxes,
      markup: '0',
      totalcharges: choosenPlan.totalpremium + riderAmount,
      totalbasecharge: 0,
      total_farequote: 0,
      paymentmode,
      total_invoice: totalInvoice + riderAmount,
      pgname: paymentmode === 'cashcard' ? '' : selectedPg,
      resultformat: 'JSON',
      insurancekey: choosenPlan?.insurancekey,
      agelimit: ages,
    };
    const res = await getInsuranceInfo(req);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      if (paymentmode === 'cashcard') {
        setAlert({
          variant: 'success',
          title: 'Insurance',
          description: res.ApiStatus.Message,
        });
        setSuccessTxId(res.ApiStatus.Result);
        //   setTimeout(() => {
        //     window.location.reload();
        //   }, 2000);
        setReviewTab(false);
        setResultsTab(false);
        scrollToTop();
        setSelectedTab('confirmation');
        setConfTab(true);
      } else {
        setAlert({
          variant: 'success',
          title: 'Insurance',
          description: `${res.ApiStatus.Message}....Redirecting to Payment Gateway`,
        });
        setTimeout(() => {
          window.location.href = `${res.ApiStatus.Result.PgUrl}?txid=${res.ApiStatus.Result.Txid}`;
        }, 2000);
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.ApiStatus?.Message || 'Failed to book Insurance',
      });
    }
    setIsLoading(false);
  };

  const [rideDetails, setRideDetails] = useState([]);
  const handleFetchAmountForRiderPlan = async (id) => {
    setRideDetails([...rideDetails, id]);
  };

  const handleSelectRidePlan = (ride) => {
    setSelectedRidersCode((prevItems) => {
      if (
        prevItems.some((selectedItem) => selectedItem.riderid === ride.riderid)
      ) {
        return prevItems.filter(
          (selectedItem) => selectedItem.riderid !== ride.riderid,
        );
      }
      return [...prevItems, ride];
    });
  };

  const isRideSelected = (ride) => {
    let isSelected = false;
    const isPresent = selectedRiderCodes.some(
      (x) => x.riderid === ride.riderid,
    );
    if (isPresent) {
      isSelected = true;
    }
    return isSelected;
  };

  const getRidersPercentage = () => {
    if (
      !choosenPlan ||
      !Array.isArray(choosenPlan.agePremiums) ||
      choosenPlan.agePremiums.length === 0
    ) {
      return;
    }
    let ridePercent = 0;
    if (selectedRiderCodes.length > 0) {
      selectedRiderCodes.forEach((ride) => {
        ridePercent += Number(ride.premiumPercent || 0);
      });
    }
    const basePremium = Number(choosenPlan.totalpremium?.toFixed(2));
    const riderCharge = Math.ceil((basePremium * ridePercent) / 100);
    setRiderAmount(riderCharge);
  };

  const updatePaymentMode = (pmselected) => {
    setPaymentMode(pmselected);
    const pgForPmSelected = selectedPaymentGatewayRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === pmselected,
    );
    if (pgForPmSelected.length > 0) {
      setSelectedPg(pgForPmSelected[0].GatewayName);
    }
    setTempPgList(pgForPmSelected);
  };
  useEffect(() => {
    getRidersPercentage();
  }, [selectedRiderCodes, costDetails.basecharges]);

  const handleSendEmail = async () => {
    setIsLoading(true);
    try {
      let fromEmail = '';
      let fromName = '';
      const res = await getUserDetails(getUserAgentId());
      if (res?.ApiStatus?.Status === 'OK') {
        const { User } = res.ApiStatus.Result;
        fromEmail = User.ContactEmail;
        fromName = `${User.FirstName} ${User.LastName}`;
        const content = document.getElementById(
          'insuranceEmailContent',
        ).innerHTML;
        const response = await emailFlightOptions(
          fromEmail,
          fromName,
          emailToSent,
          content,
          'Your booking details for Travel Insurance',
        );
        if (response && response?.Root?.Status === 'OK') {
          setAlert({
            title: 'Email',
            description: 'Email Sent Successfully',
            variant: 'success',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        } else {
          setAlert({
            title: 'Email',
            description: response?.Root?.Message
              ? response?.Root?.Message
              : 'Failed to send email',
            variant: 'error ',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        }
      } else {
        setAlert({
          title: 'User Details',
          description: res?.ApiStatus?.Message
            ? res?.ApiStatus?.Message
            : 'Failed to load Agent Details',
          variant: 'error ',
        });
        setEmailToSent('');
        setShowEmailModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      setShowEmailModal(false);
      setIsLoading(false);
      setAlert({
        title: 'User Details',
        description: 'Failed to load Agent Details',
        variant: 'error ',
      });
    }
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setEmailToSent('');
  };

  const handleFetchAvailabilePlans = async () => {
    setIsLoading(true);
    // handleSubmit();
    if (
      isEmpty(selectedCategory) ||
      isEmpty(depDate) ||
      isEmpty(arrDate) ||
      isEmpty(numDays)
    ) {
      setValidationError(true);
      scrollToTop();
      setIsLoading(false);
      return false;
    }
    const actioncode = 'GETDOLPHINPLANS';
    const ages = paxDetails.map((obj) => obj.age).join('#');
    const res = await getInsuranceInfo({
      actioncode,
      opid: 'RQ000',
      age: ages,
      // age: leadpaxAge,
      daylimit: numDays,
      domInt,
      categorycode: selectedCategoryCode,
      categoryid: selectedCategory,
      noofpax: numPax,
      fromdate: formatDate(depDate, API_DATE_FORMAT),
      todate: formatDate(arrDate, API_DATE_FORMAT),
    });
    setValidationError(false);
    if (
      res &&
      res.ApiStatus.Status === 'OK' &&
      Array.isArray(res?.ApiStatus?.Result?.insurers)
    ) {
      const insurers = res.ApiStatus.Result.insurers;
      setPlanOptions(insurers);
      setSelectedTab('results');
      setResultsTab(true);
      setSearchTab(false);
    } else {
      setPlanOptions([]);
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: (res && res.ApiStatus.Status) || 'Failed to fetch details',
      });
    }
    setIsLoading(false);
  };

  const getAge = (dob) => {
    if (dob !== '') {
      const numYears = differenceInYears(
        getNewDate(TODAY_DATE),
        getNewDate(dob),
      );
      return numYears;
    }
    return '';
  };

  const handleLeadPaxDobSelect = (date) => {
    setLeadPaxDob(date);
    getAge(date);
  };
  const handlePaxDobSelect = (date, index) => {
    if (isEmpty(depDate)) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Please select Departure Date',
      });
      return false;
    }
    const list = [...paxDetails];
    list[index].dob = date;
    const paxAge = getAge(date);
    list[index].age = paxAge;
    setPaxDetails(list);
  };

  useEffect(() => {
    // Load the first 30 hotels when search results change
    setVisibleOptions(planOptions.slice(0, 30));
  }, [planOptions]);

  const loadMoreHotels = () => {
    const currentCount = visibleOptions.length;
    const newHotels = planOptions.slice(currentCount, currentCount + 30);

    // Add the next batch of hotels
    setVisibleOptions((prev) => [...prev, ...newHotels]);

    // Stop loading if we've loaded all hotels
    // if (currentCount + 30 >= searchResults.length) {
    //   setHasMore(false);
    // }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY; // Amount the page has been scrolled vertically
      const scrollHeight = document.documentElement.scrollHeight; // Total height of the document
      const clientHeight = window.innerHeight; // Height of the visible viewport

      // Check if the user has scrolled near the bottom
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreHotels();
      }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleOptions]);

  const handlePgSelection = (pgname) => {
    setSelectedPg(pgname);
    // setIsPayuPgAccepted(false);
  };

  const goToReviewTab = () => {
    let isValid = true;

    setPassportValidationError({});

    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(selectedCategory) ||
        isEmpty(selectedPlan) ||
        isEmpty(depDate) ||
        isEmpty(arrDate) ||
        isEmpty(numDays) ||
        isEmpty(paxDetail.paxname) ||
        isEmpty(paxDetail.address1) ||
        isEmpty(paxDetail.district) ||
        isEmpty(paxDetail.city) ||
        isEmpty(paxDetail.state) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.country) ||
        isEmpty(paxDetail.phoneno) ||
        isEmpty(paxDetail.mobile) ||
        !isValidMobileNumber(paxDetail.phoneno, countryCode) ||
        !isValidMobileNumber(paxDetail.mobile, countryCode) ||
        isEmpty(paxDetail.emailaddress) ||
        isEmpty(paxDetail.nominee) ||
        isEmpty(paxDetail.relation)
      ) {
        isValid = false;
        setValidationError(true);
        scrollToTop();
        return false;
      }

      if (domInt === 'international' && isEmpty(paxDetail.passportnumber)) {
        isValid = false;
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });

    // Check for duplicate passport numbers
    if (checkDuplicatePassports()) {
      isValid = false;
      const newErrors = {};
      const passportNumbers = paxDetails.map((pax) =>
        pax.passportnumber?.trim().toLowerCase(),
      );

      passportNumbers.forEach((passport, index) => {
        if (
          passport &&
          passportNumbers.indexOf(passport) !==
            passportNumbers.lastIndexOf(passport)
        ) {
          newErrors[index] = true;
        }
      });

      setPassportValidationError(newErrors);
      setAlert({
        variant: 'error',
        title: 'Validation Error',
        description: 'Each passenger must have a unique passport number',
      });
      scrollToTop();
    }

    if (isValid) {
      setSelectedTab('review');
      setDetailsTab(false);
      setReviewTab(true);
      scrollToTop();
    }
  };

  const handleSelectTripType = (type) => {
    setTripType(type);
    if (type === 'single') {
      setCategoryOptions(singleTripCategoryOptions);
      setSelectedCategory(singleTripCategoryOptions[0].value);
      setSelectedCategoryCode(singleTripCategoryOptions[0].categorycode);
      setDomint(singleTripCategoryOptions[0].domint);
      if (numDays === 365) {
        setNumDays('');
        setArrDate('');
      }
    }
    if (type === 'annualMulti') {
      setCategoryOptions(annualTripCategoryOptions);
      setSelectedCategory(annualTripCategoryOptions[0].value);
      setSelectedCategoryCode(annualTripCategoryOptions[0].categorycode);
      setDomint(annualTripCategoryOptions[0].domint);
      setNumDays(365);
      if (!isEmpty(depDate)) {
        const formattedDepDate = getNewDate(depDate);
        setArrDate(add(formattedDepDate, { days: 365 }));
      }
    }
  };

  const handleSetNumPax = (value) => {
    setNumPax(value);
    const newList = new Array(parseInt(value, 10)).fill(0).map(() => ({
      paxname: '',
      address1: '',
      address2: '',
      district: '',
      stateName: '',
      zipCode: '',
      country: '',
      phoneNum: '',
      mobile: '',
      email: '',
      nominee: '',
      relation: '',
      passportnumber: '',
      age: '',
    }));
    setPaxDetails(newList);
  };

  const handleTabSelection = (tab, isDisableSelection) => {
    if (isDisableSelection) {
      return false;
    }
    setSelectedTab(tab);
  };

  return (
    <div className="visa-page pb-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {categoryOptions.length >= 0 && (
        <>
          <div className="visa-page_banner" />
          <div className="visa-page_container">
            <div className="visa-page_container_header">Trip Protection</div>
            <div className="visa-page_container_form my-2">
              <div className="align-items-center d-flex flex-wrap gap-2 p-2">
                <AppButton
                  btnText="Trip Protection Search"
                  onClick={() => handleTabSelection('search')}
                  variant={selectedTab === 'search' ? 'primary' : 'outlined'}
                  disabled={!searchTab}
                />
                <AppButton
                  btnText="Results"
                  onClick={() => handleTabSelection('results')}
                  variant={selectedTab === 'results' ? 'primary' : 'outlined'}
                  disabled={!resultsTab}
                />
                <AppButton
                  btnText="Passenger Details"
                  onClick={() => handleTabSelection('details')}
                  variant={selectedTab === 'details' ? 'primary' : 'outlined'}
                  disabled={!detailsTab}
                />
                <AppButton
                  btnText="Review"
                  onClick={() => handleTabSelection('review')}
                  variant={selectedTab === 'review' ? 'primary' : 'outlined'}
                  disabled={!reviewTab}
                />
                <AppButton
                  btnText="Trip Protection Confirmation"
                  onClick={() => handleTabSelection('confirmation')}
                  variant={
                    selectedTab === 'confirmation' ? 'primary' : 'outlined'
                  }
                  disabled={!confTab}
                />
              </div>
              <div className="p-2">
                {selectedTab === 'search' && (
                  <Row className="spacing-8">
                    <Row
                      style={{
                        display: 'none',
                      }}
                    >
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="d-flex gap-2 align-items-center my-2"
                      >
                        <AppRadioInput
                          id="normal"
                          name="searchtype"
                          labelText="Single Trip"
                          value="single"
                          onChange={() => handleSelectTripType('single')}
                          checked={tripType === 'single'}
                        />
                        <AppRadioInput
                          id="student"
                          name="searchtype"
                          labelText="Annual Multi Trip"
                          value="annualMulti"
                          onChange={() => handleSelectTripType('annualMulti')}
                          checked={tripType === 'annualMulti'}
                        />
                      </Col>
                    </Row>
                    <Row className="spacing-8">
                      <Col lg={3} md={4} sm={6} xs={12}>
                        <AppSelect
                          required
                          name="category"
                          placeholder=""
                          label="Destination"
                          options={categoryOptions}
                          onSelect={handleCategorySelect}
                          isClearable={false}
                          selectedValue={selectedCategory}
                          errorText={
                            validationError && 'please select category'
                          }
                        />
                      </Col>
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppDatePicker
                          label="Departure Date"
                          className="app-date-picker"
                          customClassName={`position-relative  ${
                            validationError && depDate === ''
                              ? 'app-error-text-border'
                              : ''
                          }`}
                          required
                          placeholder=""
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          isCustomeInput={false}
                          minDate={getNewDate(TODAY_DATE)}
                          maxDate={arrDate !== '' ? arrDate : ''}
                          selectedDate={depDate}
                          onChange={(date) => handelSetDepDate(date)}
                          labelClassName="app-date-label"
                        />
                        {validationError && depDate === '' && (
                          <small className="app-error-text">
                            select departure date
                          </small>
                        )}
                      </Col>
                      {tripType === 'single' && (
                        <Col lg={3} md={3} sm={4} xs={6}>
                          <AppDatePicker
                            required
                            label="Arrival Date"
                            className="app-date-picker"
                            customClassName={`position-relative  ${
                              validationError && arrDate === ''
                                ? 'app-error-text-border'
                                : ''
                            }`}
                            placeholder=""
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            isCustomeInput={false}
                            minDate={
                              depDate !== '' ? depDate : getNewDate(TODAY_DATE)
                            }
                            selectedDate={arrDate}
                            openToDate={
                              depDate
                                ? getNewDate(depDate)
                                : getNewDate(TODAY_DATE)
                            }
                            onChange={(date) => handelSetArrDate(date)}
                            labelClassName="app-date-label"
                          />
                          {validationError && arrDate === '' && (
                            <small className="app-error-text">
                              select arrival date
                            </small>
                          )}
                        </Col>
                      )}
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppNumberInput
                          required
                          placeholderText=""
                          name="numDays"
                          label="Duration (Days)"
                          value={numDays}
                          readOnly={tripType === 'annualMulti'}
                          onChange={(d) => handleNumDaysChange(d)}
                          errorText={
                            validationError && 'please enter no of days'
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="spacing-8">
                      <Col lg={3} md={4} sm={6} xs={12}>
                        <div>
                          <AppSelect
                            required
                            name="numPax"
                            placeholder=""
                            label="No.of pax"
                            options={paxDropDown}
                            onSelect={(dataObj) =>
                              handleSetNumPax(dataObj.value)
                            }
                            isClearable={false}
                            selectedValue={numPax}
                          />
                        </div>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        {paxDetails.map((pax, index) => (
                          <Row className="spacing-8 mb-2" key={index}>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <AppDatePicker
                                required
                                label={`Date of Birth Pax (${index + 1})`}
                                className="app-date-picker"
                                customClassName={`position-relative  ${
                                  validationError && pax.dob === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder=""
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                isCustomeInput={false}
                                maxDate={getNewDate(TODAY_DATE)}
                                selectedDate={getNewDate(pax.dob)}
                                // onChange={handleLeadPaxDobSelect}
                                onChange={(date) => {
                                  handlePaxDobSelect(date, index);
                                }}
                                labelClassName="app-date-label"
                              />
                              {validationError && isEmpty(pax.dob) && (
                                <small className="app-error-text">
                                  select birth date
                                </small>
                              )}
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <AppNumberInput
                                required
                                placeholderText=""
                                name="age"
                                label={`Age (Pax ${index + 1})`}
                                value={pax.age}
                                disabled
                              />
                            </Col>
                          </Row>
                        ))}
                      </Col>
                      <Col
                        lg={3}
                        md={4}
                        sm={6}
                        xs={12}
                        className="d-flex align-items-center fs-14"
                      >
                        <AppButton
                          variant="primary"
                          btnText="Fetch Plans"
                          className="insurance-fetch-btn"
                          onClick={handleFetchAvailabilePlans}
                        />
                      </Col>
                    </Row>
                  </Row>
                )}
                {selectedTab === 'results' && (
                  <Row className="spacing-8">
                    <>
                      <div>
                        <AppButton
                          btnText="Modify Search"
                          variant="secondary"
                          className="fs-12"
                          onClick={() => {
                            setSearchTab(true);
                            setResultsTab(false);
                            setSelectedTab('search');
                          }}
                        />

                        <AppButton
                          style={{
                            display: 'none',
                          }}
                          btnText="Email Selected Quotes"
                          variant="secondary"
                          className="fs-12"
                          onClick={() => setShowEmailModal(true)}
                        />
                      </div>
                      {visibleOptions.length > 0 &&
                        visibleOptions.map((plans, index) =>
                          Array.isArray(plans.plans)
                            ? plans.plans.map((plan, planIndex) => (
                                <Card key={plan.recordid}>
                                  <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <div>
                                          <b>{plan?.planname}</b>
                                        </div>

                                        <div>
                                          <Card.Link
                                            href="#"
                                            onClick={() =>
                                              handleGetPlanBenifits(plan)
                                            }
                                          >
                                            Cover Details
                                          </Card.Link>
                                        </div>

                                        <div
                                          style={{
                                            display: 'none',
                                          }}
                                          className="text-center"
                                        >
                                          <AppCheckBox
                                            labelText="Email"
                                            checked={emailPlans.some(
                                              (selected) =>
                                                selected.recordid ===
                                                plan?.recordid,
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(plan)
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="text-center d-flex flex-column align-items-center gap-2">
                                        <div className="insurance-plan-price">
                                          <span className="insurance-plan-price__label">
                                            Total Price
                                          </span>
                                          <span className="insurance-plan-price__amount">
                                            {formatCurrency(plan?.totalpremium)}
                                          </span>
                                        </div>
                                        {appConfig?.showDiscountedPrice ? (
                                          <AppLink
                                            linkText="Check Discounted Price"
                                            className="fs-12"
                                            variant="secondary"
                                            onClick={() =>
                                              handlePlanSelect(plan)
                                            }
                                          />
                                        ) : (
                                          <AppButton
                                            btnText="Choose This Plan"
                                            className="insurance-choose-btn"
                                            variant="primary"
                                            onClick={() => {
                                              handlePlanSelect(plan);
                                            }}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              ))
                            : null,
                        )}
                    </>
                  </Row>
                )}
                {selectedTab === 'details' && (
                  <Row>
                    <Col lg={9}>
                      {selectedPlan !== '' && (
                        <>
                          {paxDetails.map((pax, index) => (
                            <div className="mt-2" key={index}>
                              <Row className="spacing-16">
                                {/* <Col lg={12}>
                                      <Row className="spacing-16">
                                        <Col lg={3} md={4} sm={6} xs={12}>
                                          <AppTextInput
                                            placeholderText=""
                                            name="txid"
                                            label="Enter Txid (if exits)"
                                            value={txId}
                                            onChange={(e) =>
                                              setTxId(e.target.value)
                                            }
                                          />
                                        </Col>
                                        <Col lg={3} md={4} sm={6} xs={12}>
                                          <AppButton
                                            btnText="Get pax Details"
                                            variant="outlined"
                                            onClick={handleGetTxDetails}
                                          />
                                        </Col>
                                      </Row>
                                    </Col> */}
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name={`paxname-${index}`}
                                    label="Pax Name"
                                    value={pax.paxname || ''}
                                    onChange={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /[^A-Za-z\s]/g,
                                        '',
                                      );
                                      handleUpdatePaxDetails(
                                        'paxname',
                                        cleaned,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError && 'please enter pax name'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppDatePicker
                                    disabled
                                    required
                                    // label={`Pax ${index + 1} DOB`}
                                    label="Pax DOB"
                                    className="app-date-picker"
                                    customClassName={`position-relative  ${
                                      validationError === ''
                                        ? 'app-error-text-border'
                                        : ''
                                    }`}
                                    placeholder=""
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    maxDate={getNewDate(TODAY_DATE)}
                                    selectedDate={getNewDate(pax.dob) || ''}
                                    // selectedDate={leadPaxDob}
                                    onChange={(date) =>
                                      handleUpdatePaxDetails(
                                        'dob',
                                        formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                        index,
                                      )
                                    }
                                    labelClassName="app-date-label"
                                  />
                                  {validationError &&
                                    pax.dob === '' &&
                                    leadPaxDob === '' && (
                                      <small className="app-error-text">
                                        select birth date
                                      </small>
                                    )}
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name={`address1-${index}`}
                                    label="Address 1"
                                    value={pax.address1 || ''}
                                    onChange={(e) =>
                                      handleUpdatePaxDetails(
                                        'address1',
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    errorText={
                                      validationError && 'please enter address1'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    placeholderText=""
                                    name={`address2-${index}`}
                                    label="Address 2"
                                    value={pax.address2 || ''}
                                    onChange={(e) =>
                                      handleUpdatePaxDetails(
                                        'address2',
                                        e.target.value,
                                        index,
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name={`district-${index}`}
                                    label="District"
                                    value={pax.district || ''}
                                    onChange={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /[^A-Za-z\s]/g,
                                        '',
                                      );
                                      handleUpdatePaxDetails(
                                        'district',
                                        cleaned,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError && 'please enter District'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name={`cityName-${index}`}
                                    label="City Name"
                                    value={pax.city || ''}
                                    onChange={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /[^A-Za-z\s]/g,
                                        '',
                                      );
                                      handleUpdatePaxDetails(
                                        'city',
                                        cleaned,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError &&
                                      'please enter city name'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name={`stateName-${index}`}
                                    label="State Name"
                                    value={pax.state || ''}
                                    onChange={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /[^A-Za-z\s]/g,
                                        '',
                                      );
                                      handleUpdatePaxDetails(
                                        'state',
                                        cleaned,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError && 'please enter state'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppNumberInput
                                    required
                                    placeholderText=""
                                    name={`zipCode-${index}`}
                                    label="Zip Code"
                                    value={pax.pincode || ''}
                                    onChange={(value) => {
                                      // Keep only numbers
                                      const cleaned = String(value).replace(
                                        /[^0-9]/g,
                                        '',
                                      );

                                      // Limit to max 6 digits (adjust if needed)
                                      const limited = cleaned.slice(0, 6);

                                      handleUpdatePaxDetails(
                                        'pincode',
                                        limited,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError && 'please enter zip code'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name="country"
                                    label="Country"
                                    value={pax.country || ''}
                                    onChange={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /[^A-Za-z\s]/g,
                                        '',
                                      );
                                      handleUpdatePaxDetails(
                                        'country',
                                        cleaned,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError && 'please enter country'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={6} xs={12}>
                                  <AppSelect
                                    className="country-codes-input"
                                    name="countryCode"
                                    id="countryCode"
                                    label="Country Code"
                                    placeholder=""
                                    required
                                    selectedValue={countryCode}
                                    options={mobileCodesForVerification}
                                    isClearable={false}
                                    errorText={
                                      validationError &&
                                      'Please Select Country Code'
                                    }
                                    onSelect={(value) =>
                                      value !== null
                                        ? setCountryCode(value.value)
                                        : setCountryCode('')
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={6} xs={12}>
                                  <AppNumberInput
                                    required
                                    placeholderText=""
                                    name="phoneNum"
                                    label="Phone Number"
                                    value={pax.phoneno || ''}
                                    onChange={(value) => {
                                      // Allow only digits
                                      const cleaned = String(value).replace(
                                        /[^0-9]/g,
                                        '',
                                      );

                                      // Restrict max length (10 digits)
                                      const limited = cleaned.slice(0, 10);

                                      handleUpdatePaxDetails(
                                        'phoneno',
                                        limited,
                                        index,
                                      );
                                    }}
                                  />
                                  {validationError &&
                                    !isValidMobileNumber(
                                      pax.phoneno,
                                      countryCode,
                                    ) && (
                                      <small className="app-error-text">
                                        Enter valid Mobile Number
                                      </small>
                                    )}
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppNumberInput
                                    required
                                    placeholderText=""
                                    name="mobile"
                                    label="Mobile"
                                    value={pax.mobile || ''}
                                    onChange={(value) => {
                                      // Allow digits only
                                      const cleaned = String(value).replace(
                                        /[^0-9]/g,
                                        '',
                                      );

                                      // Restrict to maximum 10 digits
                                      const limited = cleaned.slice(0, 10);

                                      handleUpdatePaxDetails(
                                        'mobile',
                                        limited,
                                        index,
                                      );
                                    }}
                                  />
                                  {validationError &&
                                    !isValidMobileNumber(
                                      pax.mobile,
                                      countryCode,
                                    ) && (
                                      <small className="app-error-text">
                                        Enter valid Mobile Number
                                      </small>
                                    )}
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name="email"
                                    label="Email"
                                    value={pax.emailaddress || ''}
                                    onChange={(e) => {
                                      handleUpdatePaxDetails(
                                        'emailaddress',
                                        e.target.value,
                                        index,
                                      );
                                    }}
                                    errorText={
                                      validationError &&
                                      'please enter a valid email'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required
                                    placeholderText=""
                                    name="nominee"
                                    label="Nominee"
                                    value={pax.nominee || ''}
                                    onChange={(e) =>
                                      handleUpdatePaxDetails(
                                        'nominee',
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    errorText={
                                      validationError && 'please enter nominee'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppSelect
                                    required
                                    selectedValue={pax.relation || ''}
                                    options={relationDropDown}
                                    isClearable={false}
                                    onSelect={(e) =>
                                      handleUpdatePaxDetails(
                                        'relation',
                                        e.value,
                                        index,
                                      )
                                    }
                                    label="Relation"
                                    errorText={
                                      validationError &&
                                      'please select Relation'
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={4} sm={6} xs={12}>
                                  <AppTextInput
                                    required="true"
                                    placeholderText=""
                                    name="passportnumber"
                                    label="Passport Number"
                                    value={pax.passportnumber || ''}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Allow only letters (A-Z) and digits (0-9)
                                      const cleaned = value.replace(
                                        /[^A-Za-z0-9]/g,
                                        '',
                                      );

                                      // Restrict length to 9 characters
                                      const limited = cleaned.slice(0, 9);

                                      handleUpdatePaxDetails(
                                        'passportnumber',
                                        limited,
                                        index,
                                      );

                                      // Clear passport validation error when user types
                                      setPassportValidationError((prev) => ({
                                        ...prev,
                                        [index]: false,
                                      }));
                                    }}
                                    errorText={
                                      (validationError &&
                                        'please enter a valid passport number') ||
                                      (passportValidationError[index] &&
                                        'Passport number must be unique')
                                    }
                                  />
                                </Col>
                              </Row>
                              <div className="separator my-2" />
                            </div>
                          ))}
                          <div className="my-2">
                            {ridesAvailable.length > 0 && (
                              <Row className="spacing-8">
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={12}
                                  className="d-flex p-2"
                                >
                                  <div className="flex-1 rides-container">
                                    <div className="rides-container_header">
                                      Riders
                                    </div>
                                    <div className="p-2 fs-14 d-flex flex-column gap-1">
                                      <table className="table-bordered text-center">
                                        <thead>
                                          <tr>
                                            <th>Select</th>
                                            <th>%</th>
                                            <th>Details</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {ridesAvailable.map((ride, index) => (
                                            <React.Fragment key={index}>
                                              <tr>
                                                <td>
                                                  <AppCheckBox
                                                    id={ride.ridercode}
                                                    onChange={() =>
                                                      handleSelectRidePlan(ride)
                                                    }
                                                    labelClassName="justify-content-center"
                                                    checked={isRideSelected(
                                                      ride,
                                                    )}
                                                  />
                                                </td>
                                                <td>{ride.premiumPercent}</td>
                                                <td>
                                                  <AppLink
                                                    linkText="Details"
                                                    variant="primary"
                                                    onClick={() => {
                                                      handleFetchAmountForRiderPlan(
                                                        ride.riderid,
                                                        index,
                                                      );
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                              {rideDetails.includes(
                                                ride.riderid,
                                              ) && (
                                                <tr>
                                                  <td
                                                    className="p-1"
                                                    colSpan={3}
                                                  >
                                                    <table className="w-100 table-bordered fs-12">
                                                      <thead>
                                                        <tr>
                                                          <th>Name</th>
                                                          <th>Amount</th>
                                                          <th>Deductibles</th>
                                                          <th>Currency</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr>
                                                          <td>
                                                            {
                                                              ride
                                                                .riderCoverages[0]
                                                                .riderCoveragename
                                                            }
                                                          </td>
                                                          <td>
                                                            {formatCurrencyWithoutSymbol(
                                                              ride
                                                                .riderCoverages[0]
                                                                .amount,
                                                            )}
                                                          </td>
                                                          <td>
                                                            {
                                                              ride
                                                                .riderCoverages[0]
                                                                .deductibles
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              ride
                                                                .riderCoverages[0]
                                                                .currency
                                                            }
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                                {/* <Col
                                lg={3}
                                md={3}
                                sm={6}
                                xs={12}
                                className="d-flex p-2"
                              >
                                <div className="flex-1 rides-container">
                                  <div className="rides-container_header">
                                    Documents
                                  </div>
                                  {documentsRequired.length > 0 && (
                                    <div className="p-2 fs-14 d-flex flex-column gap-1">
                                      {documentsRequired.map((doc) => (
                                        <span key={doc.documentcode}>
                                          {doc.documentname}
                                        </span>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </Col> */}
                              </Row>
                            )}
                          </div>
                          <div className="d-flex justify-content-center mt-2">
                            <AppButton
                              btnText="Proceed to Booking Review →"
                              variant="primary"
                              className="insurance-proceed-btn px-4 mt-4"
                              onClick={goToReviewTab}
                            />
                          </div>
                        </>
                      )}
                    </Col>
                    <Col lg={3} md={3} sm={6} xs={12} className="d-flex p-2">
                      <div className="flex-1 rides-container gap-2">
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Base fare :</div>
                          <div className="fs-14 fw-500">
                            INR {choosenPlan.totalpremium.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Management Fee :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.handlingcharges.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">GST :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.servicetax.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Commission :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.commission.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">TDS :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.tds.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Rider Amount :</div>
                          <div className="fs-14 fw-500">
                            INR {parseFloat(riderAmount).toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Total Invoice :</div>
                          <div className="fs-14 fw-500">
                            INR{' '}
                            {(totalInvoice + parseFloat(riderAmount)).toFixed(
                              2,
                            )}
                          </div>
                        </div>
                        <div className="d-flex">
                          <span className="mt-2 d-flex align-items-center flex-1 justify-content-between fs-12">
                            Total Premium Amount is{' '}
                            <span className="fw-500 fs-14">
                              INR{' '}
                              {(totalInvoice + Number(riderAmount)).toFixed(2)}
                            </span>
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                {selectedTab === 'review' && (
                  <Row>
                    <Col lg={9} md={9} sm={12} xs={12}>
                      <div className="m-3 fs-16 fw-600">{choosenPlan.name}</div>
                      <div>
                        {paxDetails.map((pax, index) => (
                          <Card key={index} className="mt-2">
                            <Card.Body>
                              <Card.Title>Passenger {index + 1}</Card.Title>
                              <Row className="spacing-8">
                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">
                                      Passenger Name :
                                    </div>
                                    <div className="fs-14 fw-500">{`${pax.paxname}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">
                                      Relation To Insured :
                                    </div>
                                    <div className="fs-14 fw-500">{`${pax.relation}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">D.O.B :</div>
                                    <div className="fs-14 fw-500">
                                      {formatDate(
                                        getNewDate(pax.dob),
                                        DATE_MONTH_YEAR_WITH_HYPHEN,
                                      )}
                                    </div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">
                                      Major Destination
                                    </div>
                                    <div className="fs-14 fw-500">{`${pax.country}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">State :</div>
                                    <div className="fs-14 fw-500">{`${pax.state}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">Pin Code :</div>
                                    <div className="fs-14 fw-500">{`${pax.pincode}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">Email :</div>
                                    <div className="fs-14 fw-500">{`${pax.emailaddress}`}</div>
                                  </div>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">
                                      Benificiary Name :
                                    </div>
                                    <div className="fs-14 fw-500">{`${pax.nominee}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">Passport No :</div>
                                    <div className="fs-14 fw-500">{`${pax.passportnumber}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">Address:</div>
                                    <div className="fs-14 fw-500">{`${pax.address1} ${pax.address2}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">City :</div>
                                    <div className="fs-14 fw-500">{`${pax.city}`}</div>
                                  </div>
                                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                    <div className="fs-12">Mobile :</div>
                                    <div className="fs-14 fw-500">{`${pax.mobile}`}</div>
                                  </div>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        ))}
                      </div>
                      <div>
                        <div className="d-flex justify-content-center mt-2">
                          <AppButton
                            btnText="Proceed"
                            variant="outlined"
                            className="px-4"
                            onClick={handleSubmit}
                          />
                        </div>
                        {showFooter && (
                          <div>
                            <div className="fs-12">
                              <p>
                                I declare that the information provided in this
                                application is correct.
                              </p>
                              <p>
                                The insured is currently in India and is a
                                resident of India holding a valid Indian
                                passport/Indian work or residence permit.The
                                applicant is above 18 years of age.
                              </p>
                              <p>
                                I also confirm that this policy is not being
                                issued to cover risks directly or indirectly
                                associated with travel in, to, or through
                                Afghanistan, Cuba or Democratic Republic of
                                Congo. I/ We hereby declare, on my behalf and on
                                behalf of all persons proposed to be insured
                                that the above statements, answers and/or
                                particulars given by me are true and complete in
                                all respects to the best of my knowledge and
                                that I/We am/ are authorized to propose on
                                behalf of these other persons.
                              </p>
                              <p>
                                I/ We understand that the information provided
                                by me will form the basis of insurance policy,
                                is subject to the Board approved underwriting
                                policy of the Insurance company and that the
                                policy will come into force only after full
                                receipt of the premium chargeable.
                              </p>
                              <p>
                                I/ We further declare that I/We will notify in
                                writing any change occurring in the occupation
                                or general health of the life to be insured/
                                proposer after the proposal has been submitted
                                but before communication of the risk acceptance
                                by the company.
                              </p>
                              <p>
                                I/We declare and consent to the company seeking
                                medical information from any doctor or from a
                                hospital who at anytime has attended on the life
                                to be insured/ proposer or from any past or
                                present employer concerning anything which
                                affects the physical and mental health of the
                                life to be assured/proposer and seeking
                                information from any insurance company to which
                                an application for insurance on the life to be
                                assured/ proposer has been made for the purpose
                                of underwriting the proposal and/or claim
                                settlement.
                              </p>
                              <p>
                                I/ We authorize the company to share information
                                pertaining to my proposal including the medical
                                records for the sole purpose of proposal
                                underwriting and/or claims settlement and with
                                any Governmental and/or Regulatory Authority.
                              </p>
                            </div>
                            <div className="mt-2 fs-12">
                              <p>AML guidelines:</p>
                              <p>
                                1. I/We hereby confirm that all premiums have
                                been/will be paid from bonafide sources and no
                                premiums have been/will be paid out of proceeds
                                of crime related to any of the offence listed in
                                preventions of Money Laundering Act, 2002.
                              </p>
                              <p>
                                2. I understand that the Company has the right
                                to call for documents to establish sources of
                                funds.
                              </p>
                              <p>
                                3. The insurance Company has right to cancel the
                                insurance contract in case I am/have been found
                                guilty by any competent court of law under any
                                of the statutes,directly or indirectly governing
                                the prevention of money laundering in India.
                              </p>
                              <p>
                                I have read and understood the above mention
                                Terms & Conditions.
                              </p>
                              <p className="my-3">
                                Section 41 of Insurance Act 1938 (Prohibition of
                                rebates): Statutory warning - 1. &quot;No person
                                shall allow or offer to allow either directly or
                                indirectly as an inducement to any person to
                                take out or renew or continue an insurance in
                                respect of any kind of risk relating to lives or
                                property in India, any rebate of the whole or
                                part of the commission payable or any rebate of
                                premium shown on the policy, nor shall any
                                person taking out or renewing or continuing a
                                policy accept any rebate, except such rebate as
                                may be allowed in accordance with the published
                                prospectus or tables of the insurers&quot;. 2.
                                If any person fails to comply with sub
                                regulation (1) above, he shall be liable to
                                payment of a fine which may extend to rupees
                                five hundred.
                              </p>
                              <p>64VB:</p>
                              <p className="mb-3">
                                Commencement of risk cover under the policy is
                                subject to receipt and realisation of payable
                                premium by Tata AIG General Insurance Company
                                Limited.
                              </p>
                              <p>General Exclusions:</p>
                              <p>
                                1. Insured Person is traveling against the
                                advice of a Physician; or is travelling for the
                                purpose of obtaining treatment.
                              </p>
                              <p>
                                2. Any Pre-existing Condition or any
                                complication arising from it; or
                              </p>
                              <p>
                                3. Suicide, attempted suicide (whether sane or
                                insane) or intentionally self inflicted Injury
                                or Illness, or sexually transmitted conditions,
                                mental or nervous disorder, anxiety, stress or
                                depression, Acquired Immune Deficiency Syndrome
                                (AIDS), Human Immune deficiency Virus (HIV)
                                infection; or
                              </p>
                              <p>
                                4. Serving in any branch of the Military or
                                Armed Forces of any country, whether in peace or
                                War,
                              </p>
                              <p>
                                5. Being under the influence of drugs, alcohol,
                                or other intoxicants or hallucinogens
                              </p>
                              <p>
                                6. Participation in an actual or attempted
                                felony, riot, crime, misdemeanor, or civil
                                commotion; or
                              </p>
                              <p>
                                7. Operating or learning to operate any
                                aircraft, or performing duties as a member of
                                the crew on any aircraft or Scheduled Airline;
                                or
                              </p>
                              <p>
                                8. Any loss arising out of War, civil war,
                                invasion, insurrection, revolution, act of
                                foreign enemy,
                              </p>
                              <p>
                                9. Any loss, damage cost or expense of
                                whatsoever nature directly or indirectly caused
                                by, resulting from or in connection with any act
                                of terrorism.
                              </p>
                              <p>
                                10. Any loss arising out of the intentional use
                                of military force to intercept, prevent, or
                                mitigate any known or suspected Act of
                                Terrorism;or
                              </p>
                              <p>
                                11. The use, release or escape of nuclear
                                materials that directly or indirectly results in
                                nuclear reaction or radiationor radioactive
                                contamination;
                              </p>
                              <p>
                                12. The radioactive, toxic, explosive or other
                                dangerous properties of any explosive nuclear
                                equipment or any part of that equipment; or
                              </p>
                              <p>
                                13. Performance of manual work for employment or
                                any other potentially dangerous occupation; or
                              </p>
                              <p>
                                14. Congenital anomalies or any complications or
                                conditions arisingtherefrom; or
                              </p>
                              <p>
                                15. Osteoporosis (porosity and brittleness of
                                the bones due to loss of protein from the bones
                                matrix) or pathological fracture (any fracture
                                in an area where pre-existing Disease has caused
                                the weakening of the bone)
                              </p>
                              <p>
                                16. Participation in winter sports,
                                skydiving/parachuting, hang gliding, bungee
                                jumping, scuba diving, mountain climbing
                              </p>
                              <p>
                                17. Pregnancy and all related conditions, This
                                however does not include ectopic pregnancy
                                proved by diagnostic means and is certified to
                                be life threatening by the Physician; or
                              </p>
                              <p>
                                18. For any loss of which a contributing cause
                                was your actual or attempted commission of, or
                                willful participation in, an illegal act or any
                                violation or attempted violation of the law or
                                Your resistance to arrest;
                              </p>
                              <p>
                                19. Any loss, injury, damage or legal liability
                                arising directly or indirectly from: Travel in,
                                to, or through Afghanistan, Cuba or Democratic
                                Republic of Congo; or
                              </p>
                              <p>
                                20. Any loss, injury, damage or legal sustained
                                directly or indirectly by: Any terrorist or
                                member of a terrorist organisation, narcotics
                                trafficker, or purveyor of nuclear, chemical or
                                biological weapons.
                              </p>
                              <p className="mt-2">
                                For complete list of detailed exclusion, please
                                refer policy wordings
                              </p>
                              <p>
                                I have read and understood the policy wordings
                              </p>
                            </div>

                            <div className="separator" />
                            <div className="">
                              <div className="flight-booking-page_title">
                                Payment options
                              </div>
                              <div className="d-flex cursor-pointer oscroll">
                                {getEligibilityForPaymentMode('wallet') && (
                                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                                  <div
                                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                      paymentmode === 'cashcard'
                                        ? 'primary-color'
                                        : 'grey-color'
                                    }`}
                                    onClick={() =>
                                      updatePaymentMode('cashcard')
                                    }
                                  >
                                    <CiWallet />
                                    Wallet
                                  </div>
                                )}
                                {getEligibilityForPaymentMode('creditcard') && (
                                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                  <div
                                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                      paymentmode === 'creditcard'
                                        ? 'primary-color'
                                        : 'grey-color'
                                    }`}
                                    onClick={() =>
                                      updatePaymentMode('creditcard')
                                    }
                                  >
                                    <MdOutlineCreditCard /> CreditCard
                                  </div>
                                )}
                                {getEligibilityForPaymentMode('debitcard') && (
                                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                  <div
                                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                      paymentmode === 'debitcard'
                                        ? 'primary-color'
                                        : 'grey-color'
                                    }`}
                                    onClick={() =>
                                      updatePaymentMode('debitcard')
                                    }
                                  >
                                    <MdOutlineCreditCard /> DebitCard
                                  </div>
                                )}
                                {getEligibilityForPaymentMode('netbanking') && (
                                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                  <div
                                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                      paymentmode === 'netbanking'
                                        ? 'primary-color'
                                        : 'grey-color'
                                    }`}
                                    onClick={() =>
                                      updatePaymentMode('netbanking')
                                    }
                                  >
                                    <CiBank />
                                    Netbanking
                                  </div>
                                )}
                                {getEligibilityForPaymentMode('upi') && (
                                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                  <div
                                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                      paymentmode === 'upi'
                                        ? 'primary-color'
                                        : 'grey-color'
                                    }`}
                                    onClick={() => updatePaymentMode('upi')}
                                  >
                                    <CiBank />
                                    UPI
                                  </div>
                                )}
                              </div>
                            </div>
                            {PaymentGateway === true &&
                              tempPgList.length > 0 &&
                              paymentmode !== 'cashcard' &&
                              paymentmode !== '' && (
                                <div className="d-flex justify-content-start gap-4">
                                  <div className="flight-booking-page_title">
                                    Payment Gateway
                                  </div>
                                  {tempPgList.map((pgdisp, index) => (
                                    <AppRadioInput
                                      key={index}
                                      id={pgdisp.GatewayName}
                                      name="paymentGateway"
                                      labelText={
                                        pgdisp.GatewayName === 'techprocessv2'
                                          ? 'Worldline'
                                          : pgdisp.GatewayName
                                      }
                                      value={pgdisp.GatewayName}
                                      onChange={() =>
                                        handlePgSelection(pgdisp.GatewayName)
                                      }
                                      checked={
                                        selectedPg === pgdisp.GatewayName
                                      }
                                    />
                                  ))}
                                </div>
                              )}
                            <div className="d-flex flex-column gap-2 align-items-center">
                              <AppCheckBox
                                labelText="I agree the Terms & Conditions"
                                id="acceptTerms"
                                name="acceptTerms"
                                checked={acceptTerms}
                                labelClassName="fs-12"
                                onChange={() => setAcceptTerms((prev) => !prev)}
                              />
                              <AppButton
                                btnText="Continue Booking"
                                variant="primary"
                                disabled={!acceptTerms}
                                onClick={handleContinueBooking}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col lg={3} md={3} sm={12} xs={12} className="d-flex p-2">
                      <div className="flex-1 rides-container gap-2">
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Base fare :</div>
                          <div className="fs-14 fw-500">
                            INR {choosenPlan.totalpremium.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Management Fee :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.handlingcharges.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">GST :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.servicetax.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Commission :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.commission.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">TDS :</div>
                          <div className="fs-14 fw-500">
                            INR {costDetails.tds.toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Rider Amount :</div>
                          <div className="fs-14 fw-500">
                            INR {parseFloat(riderAmount).toFixed(2)}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                          <div className="fs-12">Total Invoice :</div>
                          <div className="fs-14 fw-500">
                            INR{' '}
                            {(totalInvoice + parseFloat(riderAmount)).toFixed(
                              2,
                            )}
                          </div>
                        </div>
                        <div className="d-flex">
                          <span className="mt-2 d-flex align-items-center flex-1 justify-content-between fs-12">
                            Total Premium Amount is{' '}
                            <span className="fw-500 fs-14">
                              INR{' '}
                              {(totalInvoice + Number(riderAmount)).toFixed(2)}
                            </span>
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                {selectedTab === 'confirmation' && (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fs-18 fw-500 green-color">
                        Insurance Booking Successful
                      </div>
                      <AppButton
                        btnText="Go To Voucher"
                        onClick={() => {
                          window.location.href = `/trip-protection/voucher/${successTxId}`;
                        }}
                      />
                    </div>

                    <div>
                      {paxDetails.map((pax, index) => (
                        <Card key={index} className="mt-2">
                          <Card.Body>
                            <Card.Title>Passenger {index + 1}</Card.Title>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Passenger Name :</div>
                                  <div className="fs-14 fw-500">{`${pax.paxname}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">
                                    Relation To Insured :
                                  </div>
                                  <div className="fs-14 fw-500">{`${pax.relation}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">D.O.B :</div>
                                  <div className="fs-14 fw-500">
                                    {formatDate(
                                      getNewDate(pax.dob),
                                      DATE_MONTH_YEAR_WITH_HYPHEN,
                                    )}
                                  </div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Major Destination</div>
                                  <div className="fs-14 fw-500">{`${pax.country}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">State :</div>
                                  <div className="fs-14 fw-500">{`${pax.state}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Pin Code :</div>
                                  <div className="fs-14 fw-500">{`${pax.pincode}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Email :</div>
                                  <div className="fs-14 fw-500">{`${pax.emailaddress}`}</div>
                                </div>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">
                                    Benificiary Name :
                                  </div>
                                  <div className="fs-14 fw-500">{`${pax.nominee}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Passport No :</div>
                                  <div className="fs-14 fw-500">{`${pax.passportnumber}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Address:</div>
                                  <div className="fs-14 fw-500">{`${pax.address1} ${pax.address2}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">City :</div>
                                  <div className="fs-14 fw-500">{`${pax.city}`}</div>
                                </div>
                                <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                                  <div className="fs-12">Mobile :</div>
                                  <div className="fs-14 fw-500">{`${pax.mobile}`}</div>
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          {showBenifitsPopup && (
            <AppModal
              modalTitle="Plan benefits"
              showFooter={false}
              showCloseButton
              className="sales-rep-details fs-14"
              onModalClose={() => setShowBenifitsPopup(false)}
            >
              {planBenifits?.coverages.length > 0 ? (
                <div className="d-flex flex-column">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Plan Benifit</th>
                        <th>Amount</th>
                        {/* <th>Deductable</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {planBenifits.coverages.map((benifit, index) => (
                        <tr key={index}>
                          <td>{benifit.covername}</td>
                          <td>
                            {Number(String(benifit.maxAmount).replace(/,/g, ''))
                              ? formatCurrencyWithoutSymbol(
                                  String(benifit.maxAmount).replace(/,/g, ''),
                                  planBenifits?.sumInsured?.split(' ')[0],
                                )
                              : benifit.maxAmount}
                          </td>
                          {/* <td>{benifit.deductable}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No Benifits Found</div>
              )}
            </AppModal>
          )}
          {showFareModal && (
            <AppModal
              modalTitle="Fare Details"
              showCloseButton
              showFooter={false}
              onModalClose={() => setShowFareModal(false)}
            >
              <div className="fare-details">
                <div className="d-flex justify-content-between mb-2">
                  <span>Base Fare</span>
                  {console.log(fareDetails)}
                  <span>₹{fareDetails?.BaseFare?.toFixed(2)}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                  <span>Discount</span>
                  <span>- ₹{fareDetails?.Commission?.toFixed(2)}</span>
                </div>

                {/* <div className="d-flex justify-content-between mb-2">
                  <span>Handling Charges</span>
                  <span>₹{fareDetails?.HandlingCharges?.toFixed(2)}</span>
                </div> */}

                <hr />

                <div className="d-flex justify-content-between fw-bold">
                  <span>Payable Amount</span>
                  <span>₹{fareDetails?.InvoiceTotal?.toFixed(2)}</span>
                </div>

                <div className="text-end mt-3">
                  <AppButton
                    variant="primary"
                    btnText="Continue"
                    onClick={handleContinue}
                  />
                </div>
              </div>
            </AppModal>
          )}
          {showEmailModal && (
            <AppModal
              modalTitle="Share Plan Details"
              showFooter={false}
              showCloseButton
              className="sales-rep-details fs-14"
              onModalClose={handleCloseEmailModal}
            >
              <div className="d-flex gap-2 align-items-center">
                <div className="flex-1">
                  <AppTextInput
                    label="Email"
                    value={emailToSent}
                    onChange={(e) => setEmailToSent(e.target.value)}
                  />
                </div>
                <AppButton btnText="Send Email" onClick={handleSendEmail} />
              </div>
            </AppModal>
          )}
        </>
      )}
      <div id="insuranceEmailContent" className="d-none">
        <div
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            margin: '10px',
          }}
        >
          <p
            style={{
              fontWeight: '600',
            }}
          >
            Dear Partner,
          </p>
          <p>As per your request, we are forwarding Travel insurance policy</p>
          <div
            style={{
              backgroundColor: '#0770e4',
              color: '#fff',
              border: '1px solid #0770e4',
            }}
          >
            <table style={{ width: '100%' }}>
              <thead>
                {emailPlans.length > 0 &&
                  emailPlans.map((plan, index) => (
                    <tr key={index}>
                      <th>{plan.name}</th>
                      <th>{plan.daylimit}D limit</th>
                      <th style={{ textAlign: 'right' }}>
                        Price: Rs {plan.premium}
                      </th>
                    </tr>
                  ))}
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsurancePageNewV3;
